import api from "../utils/axios";
import { useQuery } from "@tanstack/react-query";

// GET all agents with their office + org details (for the "By Office" / "By Agent" picker)
export const useAgentsWithOfficeQuery = () => {
  return useQuery({
    queryKey: ["agentsWithOffice"],
    queryFn: async () => {
      const res = await api.get("/admin/user/agentsWithOffice");
      return res.data?.data || [];
    },
    staleTime: 10 * 60 * 1000, // list barely changes — cache 10 min
  });
};
